export default {
  listTypesOfPaymentReceipts: [],
  typeOfPaymentReceipt: {
    descricao: '',
    planoDeConta: {
      id: null,
    },
    ativo: true,
    temMulta: false,
    percentualMulta: null,
    temJuro: false,
    percentualJuroDiario: null,
    permiteDesconto: false,
    percentualDescontoMax: null,
    permiteAntecipacao: false,
    percentualAntecipacao: null,
  },
  comboPlanoConta: [],
}
